const converDate = (date)=>{
        const mois = ["janvier","fevrier","mars","avril","mai","juin","juillet","aout","septembre","octobre","novembre","decembre"]
        const mois_chiffre = ["01","02","03","04","05","06","07","08","09","10","11","12"]
        const jours = ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"]
        const jours_short = ["dim","lun","mar","mer","jeu","ven","sam"]
        const d = new Date(date)
        //const heure= d.getHours() 
        const heure = date.split('-')[2].split('T')[1]
        const annee = d.getFullYear()
        const minute=d.getMinutes()
        //const jour=d.getDate()
        const jour=date.split('-')[2].split('T')[0]
        const jour_clair=jours_short[d.getDay()]
        const mois_clair = mois[d.getMonth()]
        //return `${jour_clair} ${jour} ${mois_clair } ${annee} ${heure}h `
        // return `${jour_clair} ${jour}/${mois_clair } ${heure}h `//version d'affichage courte sans l'année parcequ'on s'en fout un peu...
        return {jour_clair,jour,mois_clair,heure}
}
export default converDate